// extracted by mini-css-extract-plugin
export default {"formation":"formation_formation__bfonZ","tiles":"formation_tiles__pJ9x5"};